import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  TableContainer, Table, TableRow, TableCell, TableHead, TableBody, makeStyles, Typography, Checkbox, Box, Modal, Button, Snackbar, Grid
} from '@material-ui/core';
import { api_call, console_log, empty } from '../helpers/untils';
import { LOCK_SETTING_VIDEO_ID } from '../config/constant';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import ModalVideo from 'react-modal-video';
import 'react-modal-video/scss/modal-video.scss';
import { Stack } from '@mui/material';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '460px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
};
const useStyles = makeStyles(() => ({
  details: {
    flexDirection: 'column',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
  },
  formContainer: {
    display: 'block',
    width: '100%',
  },
  formRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  commandLabelBlock: {
    flex: 1,
  },
  inputRadioBlock: {
    flex: 1,
  },
  inputRadio2Block: {
    flex: 2,
  },
  imgSmall: {
    width: '50px',
    height: '42px',
    marginLeft: '5px',
    marginTop: '16px',
    marginBottom: '8px',
    borderRadius: '4px',
    cursor: 'pointer',
    objectFit: 'cover',
    objectPosition: 'center'
  },
  checkboxTdColumn: {
    paddingLeft: '16px'
  }
}));

const PartnerInsuranceModal = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const user = useSelector((state) => state.session.user);
  const { open, setOpen, item, setItem } = props;
  const [updateTimestamp, setUpdateTimestamp] = useState(0)

  const handleModalClose = () => {
    setOpen(false)
  }
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const [apiCalling, setApiCalling] = useState(false)
  const defaultFormData = {
    checked: [],
    streamingList: []
  }
  const [formData, setFormData] = useState(defaultFormData)

  const loadPageData = async () => {
    setApiCalling(true)
    const response = await api_call(`/api/user-streaming/get-streaming-list?device_id=${item.id}`);
    if (response.ok) {
      setApiCalling(false)
      const res = await response.json()
      setFormData({ ...defaultFormData, ...res })
    }
  }

  useEffect(() => {
    loadPageData()
  }, [item]);

  const handleSaveSetting = async () => {
    const url = `/api/user-streaming/save`;
    const payload = {
      user_id: user.id,
      device_id: item.id,
      streamingSetting: formData
    }
    setApiCalling(true)
    let response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    setApiCalling(false)
    if (response.ok) {
      const apiData = await response.json()
      setToastMessage(`Saved successfully!`);
      setSnackbarOpen(true);

      setTimeout(() => {
        handleModalClose()
      }, 1000)
    } else {
      const apiError = response
      console_log("apiError:::", apiError)
      setToastMessage(apiError.error);
      setSnackbarOpen(true);
    }
  }

  const handleCheck = (field, event) => {
    // console.log(`event.target.checked:`, event.target.checked);
    // setChecked((prev) => ({ ...prev, [field]: event.target.checked }));
    const checked = formData['checked'] || [];
    if (event.target.checked) {
      if (!checked.includes(field)) {
        checked.push(field);
      }
    } else {
      checked.splice(checked.indexOf(field), 1);
    }
    setFormData({ ...formData, checked: checked })
  }

  const onClickSetAllUserCarStreaming = async (streamingId) => {
    const checked = formData['checked'] || [];
    let streamingChecked = false;
    if (checked.includes(streamingId)) {
      streamingChecked = true
    } else {
      streamingChecked = false
    }
    setApiCalling(true)
    const url = `/api/user-streaming/set-all-user-car-streaming`;
    const payload = { user_id: user.id, device_id: item.id, streamingId: streamingId, streamingChecked: streamingChecked ? 1 : 0 }
    let response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    setApiCalling(false)
    if (response.ok) {
      const apiData = await response.json()
      setToastMessage(`Set all user car streaming successfully!`);
      setSnackbarOpen(true);
    } else {
      const apiError = response
      console_log("apiError:::", apiError)
      setToastMessage(apiError.error);
      setSnackbarOpen(true);
    }
  }

  const [videoOpen, setVideoOpen] = useState(false)
  const onClickVideoLink = () => {
    setVideoOpen(true)
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box>
          <Box sx={modalStyle}>
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              open={snackbarOpen}
              onClose={() => { setSnackbarOpen(false) }}
              autoHideDuration={1500}
              message={toastMessage}
            />
            <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
              <Grid item>
                <Typography variant='h6'>Partners and Insurance Settings</Typography>
              </Grid>
              <Grid item>
                {/* <Typography variant='p' onClick={() => onClickVideoLink()} style={{ cursor: 'pointer', textDecoration: 'underline', color: '#1366ff' }}>Video</Typography> */}
              </Grid>
            </Grid>

            <div className='mt-4'>
              <div className={classes.formContainer} style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <Stack direction={`column`} spacing={1}>
                  {
                    formData.streamingList.map((streaming, index) => (
                      <div key={index} className={classes.checkboxTdColumn}>
                        <Stack
                          direction={`row`}
                          alignItems={`center`}
                          justifyContent={`space-between`}
                          style={{ width: "100%" }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formData.checked.includes(streaming.id)}
                                onChange={(event) =>
                                  handleCheck(streaming.id, event)
                                }
                              />
                            }
                            label={streaming.partner_name}
                          />
                          <>
                            {
                              (!user.administrator) ? (
                                <>
                                  <Button
                                    type="button"
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    style={{
                                      borderRadius: "80px",
                                      height: "30px",
                                      textTransform: "none",
                                      lineHeight: 1,
                                    }}
                                    disabled={apiCalling}
                                    onClick={() =>
                                      onClickSetAllUserCarStreaming(streaming.id)
                                    }
                                  >
                                    All Cars
                                  </Button>
                                </>
                              ) : (
                                <></>
                              )
                            }
                          </>
                        </Stack>
                      </div>
                    ))
                  }
                </Stack>
              </div>
              <div className={classes.buttons} style={{ paddingTop: '15px', width: '100%', margin: 'auto' }}>
                <Button type="button" color="primary" variant="contained" onClick={() => handleSaveSetting()} disabled={apiCalling}>
                  Save
                </Button>
                <Button type="button" color="primary" variant="outlined" onClick={() => setOpen(false)}>
                  Close
                </Button>
              </div>
            </div>

          </Box>
          <React.Fragment>
            {
              (videoOpen && LOCK_SETTING_VIDEO_ID !== "") ? (
                <>
                  <ModalVideo
                    channel='youtube'
                    autoplay={1}
                    youtube={{
                      autoplay: 1,
                      mute: 1
                    }}
                    isOpen={videoOpen}
                    videoId={LOCK_SETTING_VIDEO_ID}
                    onClose={() => setVideoOpen(false)}
                  />
                </>
              ) : (<></>)
            }
          </React.Fragment>

        </Box>

      </Modal>

    </>
  );
};

export default PartnerInsuranceModal;
